export default __webpack_public_path__ + "dccfb6717dcc667233157ca59b5bfb1d.png";